import { render, staticRenderFns } from "./YearlyRentalPrice.vue?vue&type=template&id=c87e1d5c&"
import script from "./YearlyRentalPrice.vue?vue&type=script&lang=ts&"
export * from "./YearlyRentalPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports